/**
 * Lazy-geladenes Praxis-Logo. Wird im Hero-Header der `AppShell` und in
 * Demo-Kontexten gerendert.
 *
 * `sizeClassName` legt Größe + Layout fest und ist überschreibbar — Default
 * passt zur Body-Karten-Darstellung, der Hero gibt eine kompaktere Variante
 * an. `className` ergänzt zusätzliche Layout-/Look-Klassen (z. B. weißer
 * Background im Hero).
 */
interface PracticeLogoProps {
  readonly src: string;
  readonly alt: string;
  readonly sizeClassName?: string;
  readonly className?: string;
}

const BASE_CLASSES = 'rounded-md object-contain';
const DEFAULT_SIZE_CLASSES = 'h-20 w-40';

export function PracticeLogo(props: PracticeLogoProps): JSX.Element {
  const sizeClassName = props.sizeClassName ?? DEFAULT_SIZE_CLASSES;
  const composedClassName =
    props.className === undefined
      ? `${BASE_CLASSES} ${sizeClassName}`
      : `${BASE_CLASSES} ${sizeClassName} ${props.className}`;
  return (
    <img
      src={props.src}
      alt={props.alt}
      loading="lazy"
      decoding="async"
      width={160}
      height={80}
      className={composedClassName}
    />
  );
}
